import React from 'react';

import { Card } from 'antd';

const CardComponent = ({
    className = '',
    classNameBody = '',
    headStyle = {},
    hoverable = true,
    size = 'small',
    title,
    bordered = false,
    style = {},
    bodyStyle = {},
    ...props
}) => {
    return (
        <Card
            className={className}
            styles={{ header: headStyle, body: bodyStyle }}
            hoverable={hoverable}
            size={size}
            title={title}
            style={style}
            {...props}
        >
            <div className={classNameBody}>{props.children}</div>
            
        </Card>
    );
};

export default CardComponent;
